import React, { useEffect, useState } from 'react'
import { Text } from '@aws-amplify/ui-react';
import { useSelector } from "react-redux"; 
import Emoji from '../lib/Emoji';

const Menue = (props) => {
    const alleMenues = useSelector(state => state.menues ? state.menues.MENUES : state.menues);
    const komponenten = useSelector(state => state.menues ? state.menues.MENUEKOMPONENTEN : state.menues);
    const [showAllergeneUndZusatzstoffe, setShowAllergeneUndZusatzstoffe] = useState(props.showAllergeneUndZusatzstoffe);

    const dasMenue = alleMenues.filter(f => f.ID === parseInt(props.menue))[0];
    const benutzteKomponenten = dasMenue ? dasMenue.KOMPONENTEN : undefined;
    const benutzteKomponentenMitNamen = benutzteKomponenten ? benutzteKomponenten.map(e => e && (e.BEZEICHNUNG > '') ? e : {...e, BEZEICHNUNG: 
        komponenten ? komponenten.filter(f => f.ID === e.ID)[0] ? komponenten.filter(f => f.ID === e.ID)[0].BEZEICHNUNG : '' : ''}) : '';
    const theLines = props.lines;

    useEffect(() => {
        if (showAllergeneUndZusatzstoffe !== props.showAllergeneUndZusatzstoffe)
            setShowAllergeneUndZusatzstoffe(props.showAllergeneUndZusatzstoffe);
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [props])

    if (!benutzteKomponentenMitNamen) return null;

    const rows = benutzteKomponentenMitNamen.map((e, i) => 
        { const komp = komponenten.filter(f => f.ID === e.ID && e.SHOW === 1)[0]
            return (komp && (komp.BEZEICHNUNG > '')) ?
            (
            <Text
                width={220}
                key={'txt_' + props.outer_index + '_' + props.index + '_' + i}
                variation={props.shouldBeVisible ? "tertiary" : "primary"}
            >{komp.BEZEICHNUNG} {showAllergeneUndZusatzstoffe && komp.ALLERGENEUNDZUSATZ > '' ? <sup key={`sup-${i}`} > {komp.ALLERGENEUNDZUSATZ}</sup> : ''} <Emoji symbol={komp.PICTOGRAMME} /></Text>
        ) : null });

    for (let i = rows.length + 1; i <= theLines; i++) {
            rows.push(<Text
            width={220}
            key={'txt_' + props.outer_index + '_' + props.index + '_' + i}
            variation={props.shouldBeVisible ? "tertiary" : "primary"}
        >&nbsp;</Text>)
    }

    return (
        <>
        {rows}
        </>
    )
}

export default Menue;